import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../shared/globals';
import { ReportSettings } from '../models/report-settings.model';
import { Station } from '../models/station.model';
import { ReportUser } from '../models/report-user.model';
import { Injectable } from '@angular/core';

/**
 * Service responsible for managing reports.
 *
 * @export
 * @class ReportsService
 */
@Injectable()
export class ReportsService {
  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private globals: Globals
  ) {}

  public createReport(settings: ReportSettings): Promise<Blob> {
    return this.authService.getToken().then((token) => {
      return this.performCreateReportRequest(token, settings);
    });
  }

  public getReportUsers(stations: Station[]): Promise<ReportUser[]> {
    return this.authService.getToken().then((token) => {
      return this.performGetReportUsersRequest(token, stations);
    });
  }

  // Internal methods

  private performCreateReportRequest(
    token: string,
    settings: ReportSettings
  ): Promise<Blob> {
    const url = new URL(this.globals.apiUrl('reports'));
    const payload = settings.serialize();

    return new Promise((resolve, reject) => {
      this.http
        .post(url.toString(), payload, {
          headers: this.authService.headers(token),
          responseType: 'blob',
        })
        .toPromise()
        .then((blob) => {
          resolve(blob);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  private performGetReportUsersRequest(
    token: string,
    stations: Station[]
  ): Promise<ReportUser[]> {
    const url = new URL(this.globals.apiUrl('reports/users'));
    const payload = { stationIds: stations.map((s) => s.ID) };

    return new Promise((resolve, reject) => {
      this.http
        .post(url.toString(), payload, {
          headers: this.authService.headers(token),
        })
        .toPromise()
        .then((response: string[]) => {
          const values = response.map((email) => {
            const user = new ReportUser();
            user.username = email;
            return user;
          });
          resolve(values);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
